const moreSpecsTable = document.querySelector('.specs__body .more-specs');
const moreSpecsBtn = document.querySelector('.specs__button a');
const specsBody = document.querySelector('.specs__body');

const collapseLanguage = {
  'en': 'View Less Specs',
  'es': 'Vea menos especificaciones',
  'pt': 'Ver menos especificações',
};
const expandLanguage = {
  'en': 'View More Specs',
  'es': 'Vea más especificaciones',
  'pt': 'Ver mais especificações',
};

moreSpecsBtn.addEventListener('click', (e) => {
  e.preventDefault();
  const activeLang = document.documentElement.lang;

  if (moreSpecsTable.classList.contains('open-specs')) {
    moreSpecsTable.classList.remove('open-specs');
    moreSpecsBtn.innerHTML = expandLanguage[activeLang];

    specsBody.scrollIntoView({ behavior: "smooth"});

  } else {
    moreSpecsTable.classList.add('open-specs');
    moreSpecsBtn.innerHTML = collapseLanguage[activeLang];
  }

});